export * from './gpdr.component';
